import React, { FunctionComponent } from "react";
import "./IconButton.css"
import SvgSelector, { SvgIconType } from "../svgSelector/SvgSelector";


interface IconButtonProps {
    type: SvgIconType,
    roundedButton?: boolean,
    onClick? : (event? : React.MouseEvent)=>void
    disabled? : boolean,
    tooltipText : string,
    tooltipPosition?: "left" 
}
 
const IconButton: FunctionComponent<IconButtonProps> = (props) => {

    let { type, roundedButton, onClick , disabled, tooltipText, tooltipPosition} = props;

    return (  
        <button className={`icon_btn ${roundedButton ? "rounded" : ""}`} onClick={onClick} disabled={disabled} >
            <SvgSelector title={type}/>
            {tooltipText && <span className={`tooltip ${tooltipPosition}`}>{tooltipText}</span>}
        </button>
    );
}
 
export default IconButton;